// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.runReportRoot[data-v-06cc24e4]
	{
		background-color: #FFFFFF;
		width: min(1100px, calc(100vw - 30px));
		height: calc(100vh - 40px);
		display: flex;
		flex-direction: column;
}
.titleBar[data-v-06cc24e4]
	{
		padding: 12px 16px 8px 16px;
		border-bottom: 1px solid #E0E0E0;
		flex: 0 0 auto;
}
.title[data-v-06cc24e4]
	{
		text-align: center;
		font-weight: bold;
		font-size: 16pt;
}
.runIdText[data-v-06cc24e4]
	{
		text-align: center;
		font-size: 0.85em;
}
.mutedText[data-v-06cc24e4]
	{
		color: #888888;
}
code.inline[data-v-06cc24e4]
	{
		font-family: Consolas, monospace;
		background-color: #F4F4F4;
		border-radius: 3px;
		padding: 0px 5px;
}
.dialogBody[data-v-06cc24e4]
	{
		flex: 1 1 auto;
		min-height: 0;
		display: flex;
		flex-direction: column;
		padding: 8px 16px;
}
.reportFrame[data-v-06cc24e4]
	{
		flex: 1 1 auto;
		width: 100%;
		border: 1px solid #DDDDDD;
		background-color: #FFFFFF;
}
.loadingRow[data-v-06cc24e4]
	{
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 20px;
}
.notAvailable[data-v-06cc24e4]
	{
		background-color: #F4F4F4;
		border: 1px solid #DDDDDD;
		color: #555555;
		padding: 12px;
}
.errorBox[data-v-06cc24e4]
	{
		background-color: #FFE0E0;
		border: 1px solid #C00000;
		color: #660000;
		padding: 8px 12px;
		white-space: pre-wrap;
}
.footer[data-v-06cc24e4]
	{
		flex: 0 0 auto;
		border-top: 1px solid #E0E0E0;
		display: flex;
		justify-content: flex-end;
		padding: 8px 16px;
}
.dialogButton[data-v-06cc24e4]
	{
		display: inline-block;
		cursor: pointer;
		font-weight: bold;
		font-size: 12pt;
		padding: 10px 22px;
		border-radius: 5px;
		color: #4A9E42;
		border: 1px solid #DDDDDD;
}
.dialogButton[data-v-06cc24e4]:hover,
		.dialogButton[data-v-06cc24e4]:focus
		{
			background-color: rgba(0,0,0,0.05);
}
`, "",{"version":3,"sources":["webpack://./www/vues/client/dbmaintenance/RunReportPopup.vue"],"names":[],"mappings":";AA4FC;;EAEC,yBAAyB;EACzB,sCAAsC;EACtC,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;AACvB;AAEA;;EAEC,2BAA2B;EAC3B,gCAAgC;EAChC,cAAc;AACf;AAEA;;EAEC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AAChB;AAEA;;EAEC,kBAAkB;EAClB,iBAAiB;AAClB;AAEA;;EAEC,cAAc;AACf;AAEA;;EAEC,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AACjB;AAEA;;EAEC,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AAClB;AAEA;;EAEC,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC1B;AAEA;;EAEC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AACd;AAEA;;EAEC,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,aAAa;AACd;AAEA;;EAEC,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACtB;AAEA;;EAEC,cAAc;EACd,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AAClB;AAEA;;EAEC,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC1B;AAEC;;;GAGC,kCAAkC;AACnC","sourcesContent":["<template>\n\t<div class=\"runReportRoot\" role=\"dialog\" aria-labelledby=\"runReportTitle\">\n\t\t<div class=\"titleBar\">\n\t\t\t<div id=\"runReportTitle\" class=\"title\" role=\"alert\">Run report<template v-if=\"subtitle\"> — {{subtitle}}</template></div>\n\t\t\t<div class=\"mutedText runIdText\">run <code class=\"inline\">{{runId}}</code></div>\n\t\t</div>\n\t\t<div class=\"dialogBody\">\n\t\t\t<div v-if=\"loading\" class=\"loadingRow\"><ScaleLoader /> Loading the report…</div>\n\t\t\t<div v-else-if=\"notAvailable\" class=\"notAvailable\">Run reports are not available yet in this build.  Server: {{error}}</div>\n\t\t\t<div v-else-if=\"error\" class=\"errorBox\">{{error}}</div>\n\t\t\t<div v-else-if=\"!html\" class=\"notAvailable\">The server returned an empty report.</div>\n\t\t\t<!-- The report is server-generated HTML (DbMigrate's BuildHtmlReport plus the orchestrator summary).  It is rendered\n\t\t\t     inside a fully sandboxed iframe (no scripts, no same-origin access, no forms, no navigation) rather than injected\n\t\t\t     into the page. -->\n\t\t\t<iframe v-else class=\"reportFrame\" sandbox=\"\" referrerpolicy=\"no-referrer\" :srcdoc=\"html\" title=\"Maintenance run report\"></iframe>\n\t\t</div>\n\t\t<div class=\"footer\">\n\t\t\t<div ref=\"closeBtn\" class=\"dialogButton\" role=\"button\" tabindex=\"0\" @click=\"DefaultClose\" @keydown.space.enter.prevent=\"DefaultClose\">Close</div>\n\t\t</div>\n\t</div>\n</template>\n\n<script>\n\t// Shows a finished run's HTML report in a sandboxed iframe.  Fetches the report itself so the dialog opens immediately.\n\timport { GetDbMaintenanceReport } from 'appRoot/api/DbMaintenance';\n\timport { isNotAvailableYet } from './runFormat';\n\n\texport default {\n\t\tprops:\n\t\t{\n\t\t\trunId: {\n\t\t\t\ttype: String,\n\t\t\t\trequired: true\n\t\t\t},\n\t\t\t/** Optional caption (e.g. the run kind and start time). */\n\t\t\tsubtitle: {\n\t\t\t\ttype: String,\n\t\t\t\tdefault: null\n\t\t\t}\n\t\t},\n\t\tdata()\n\t\t{\n\t\t\treturn {\n\t\t\t\tloading: true,\n\t\t\t\thtml: null,\n\t\t\t\terror: null\n\t\t\t};\n\t\t},\n\t\tcomputed:\n\t\t{\n\t\t\tnotAvailable()\n\t\t\t{\n\t\t\t\treturn isNotAvailableYet(this.error);\n\t\t\t}\n\t\t},\n\t\tcreated()\n\t\t{\n\t\t\tGetDbMaintenanceReport(this.runId)\n\t\t\t\t.then(result =>\n\t\t\t\t{\n\t\t\t\t\tif (result.error)\n\t\t\t\t\t{\n\t\t\t\t\t\tthis.error = result.error;\n\t\t\t\t\t\treturn;\n\t\t\t\t\t}\n\t\t\t\t\tthis.html = typeof result.html === 'string' ? result.html : null;\n\t\t\t\t})\n\t\t\t\t.catch(ex =>\n\t\t\t\t{\n\t\t\t\t\tthis.error = ex.message || String(ex);\n\t\t\t\t})\n\t\t\t\t.finally(() =>\n\t\t\t\t{\n\t\t\t\t\tthis.loading = false;\n\t\t\t\t});\n\t\t},\n\t\tmethods:\n\t\t{\n\t\t\tSetFocus()\n\t\t\t{\n\t\t\t\tif (this.$refs.closeBtn)\n\t\t\t\t\tthis.$refs.closeBtn.focus();\n\t\t\t},\n\t\t\tDefaultClose()\n\t\t\t{\n\t\t\t\tthis.$emit('close', false);\n\t\t\t}\n\t\t}\n\t}\n</script>\n\n<style scoped>\n\t.runReportRoot\n\t{\n\t\tbackground-color: #FFFFFF;\n\t\twidth: min(1100px, calc(100vw - 30px));\n\t\theight: calc(100vh - 40px);\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\n\t.titleBar\n\t{\n\t\tpadding: 12px 16px 8px 16px;\n\t\tborder-bottom: 1px solid #E0E0E0;\n\t\tflex: 0 0 auto;\n\t}\n\n\t.title\n\t{\n\t\ttext-align: center;\n\t\tfont-weight: bold;\n\t\tfont-size: 16pt;\n\t}\n\n\t.runIdText\n\t{\n\t\ttext-align: center;\n\t\tfont-size: 0.85em;\n\t}\n\n\t.mutedText\n\t{\n\t\tcolor: #888888;\n\t}\n\n\tcode.inline\n\t{\n\t\tfont-family: Consolas, monospace;\n\t\tbackground-color: #F4F4F4;\n\t\tborder-radius: 3px;\n\t\tpadding: 0px 5px;\n\t}\n\n\t.dialogBody\n\t{\n\t\tflex: 1 1 auto;\n\t\tmin-height: 0;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tpadding: 8px 16px;\n\t}\n\n\t.reportFrame\n\t{\n\t\tflex: 1 1 auto;\n\t\twidth: 100%;\n\t\tborder: 1px solid #DDDDDD;\n\t\tbackground-color: #FFFFFF;\n\t}\n\n\t.loadingRow\n\t{\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\t\tpadding: 20px;\n\t}\n\n\t.notAvailable\n\t{\n\t\tbackground-color: #F4F4F4;\n\t\tborder: 1px solid #DDDDDD;\n\t\tcolor: #555555;\n\t\tpadding: 12px;\n\t}\n\n\t.errorBox\n\t{\n\t\tbackground-color: #FFE0E0;\n\t\tborder: 1px solid #C00000;\n\t\tcolor: #660000;\n\t\tpadding: 8px 12px;\n\t\twhite-space: pre-wrap;\n\t}\n\n\t.footer\n\t{\n\t\tflex: 0 0 auto;\n\t\tborder-top: 1px solid #E0E0E0;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\tpadding: 8px 16px;\n\t}\n\n\t.dialogButton\n\t{\n\t\tdisplay: inline-block;\n\t\tcursor: pointer;\n\t\tfont-weight: bold;\n\t\tfont-size: 12pt;\n\t\tpadding: 10px 22px;\n\t\tborder-radius: 5px;\n\t\tcolor: #4A9E42;\n\t\tborder: 1px solid #DDDDDD;\n\t}\n\n\t\t.dialogButton:hover,\n\t\t.dialogButton:focus\n\t\t{\n\t\t\tbackground-color: rgba(0,0,0,0.05);\n\t\t}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
